import { ImgHTMLAttributes } from 'react';

import { cn } from '@/components/ui';

interface Props extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  reverse?: boolean;
  isIcon?: boolean;
}

const LogoSection = ({ className, isIcon, reverse: _reverse, ...props }: Props) => (
  <img
    src="/app-logo.png"
    alt="app logo"
    className={cn(isIcon ? 'size-8 object-contain' : 'w-16 object-contain', className)}
    {...props}
  />
);

export default LogoSection;
